// store.js
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { homepageApi } from "../api/homepageApi";
import { searchApi } from "../api/searchApi";
import { musicArtistSongpageApi } from "../api/musicArtistSongPageApi";
import { musicArtistAlbumpageApi } from "../api/musicArtistAlbumPageApi";

/*** Audio ***/
import { audioHomepageApi } from "../api/audioHomePageApi";
import { audioSeeAllApi } from "../api/audioSeeAllPageApi";
import { audioBookBySeriesPageApi } from "../api/audioBookBySeriesPageApi";
import { audioBookByDetailPageApi } from "../api/audioBookByDetailPageApi";
import { audioCategoryListPageApi } from "../api/audioCategroyListPageApi";
import { audioBookByCategoryPageApi } from "../api/audioBookByCategoryPageApi";
import { audioAllPublisherPageApi } from "../api/audioAllPublisherPageApi";
import { audioBookByAuthorPageApi } from "../api/audioBookByAuthorPageApi";
import { audioStreamingPageApi } from "../api/audioStreamingPageApi";
import { audioBookDetailRelatedPageApi } from "../api/audioRelatedPageApi";

/*** paymentListPageApi ***/
import { paymentListPageApi } from "../api/paymentListPageApi";

/*** Account Api ***/
import { myAccountPageApi } from "../api/MyAccountPageApi";
import { audioPurchasedBookPageApi } from "../api/audioPurchasedBookPageApi";

export const appStore = configureStore({
  reducer: combineReducers({
    [homepageApi.reducerPath]: homepageApi.reducer,
    [searchApi.reducerPath]: searchApi.reducer,
    [audioHomepageApi.reducerPath]: audioHomepageApi.reducer,
    [audioSeeAllApi.reducerPath]: audioSeeAllApi.reducer,
    [audioBookBySeriesPageApi.reducerPath]: audioBookBySeriesPageApi.reducer,
    [audioBookByDetailPageApi.reducerPath]: audioBookByDetailPageApi.reducer,
    [audioCategoryListPageApi.reducerPath]: audioCategoryListPageApi.reducer,
    [audioBookByCategoryPageApi.reducerPath]: audioBookByCategoryPageApi.reducer,
    [audioAllPublisherPageApi.reducerPath]: audioAllPublisherPageApi.reducer,
    [audioBookByAuthorPageApi.reducerPath]: audioBookByAuthorPageApi.reducer,
    [myAccountPageApi.reducerPath]: myAccountPageApi.reducer,
    [audioStreamingPageApi.reducerPath]: audioStreamingPageApi.reducer,
    [paymentListPageApi.reducerPath]: paymentListPageApi.reducer,
    [musicArtistSongpageApi.reducerPath]: musicArtistSongpageApi.reducer,
    [musicArtistAlbumpageApi.reducerPath]: musicArtistAlbumpageApi.reducer,
    [audioBookDetailRelatedPageApi.reducerPath]: audioBookDetailRelatedPageApi.reducer,
    [audioPurchasedBookPageApi.reducerPath]: audioPurchasedBookPageApi.reducer
  }),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      homepageApi.middleware,
      searchApi.middleware,
      audioHomepageApi.middleware,
      audioSeeAllApi.middleware,
      audioBookBySeriesPageApi.middleware,
      audioBookByDetailPageApi.middleware,
      audioCategoryListPageApi.middleware,
      audioBookByCategoryPageApi.middleware,
      audioAllPublisherPageApi.middleware,
      audioBookByAuthorPageApi.middleware,
      myAccountPageApi.middleware,
      audioStreamingPageApi.middleware,
      paymentListPageApi.middleware,
      musicArtistSongpageApi.middleware,
      musicArtistAlbumpageApi.middleware,
      audioBookDetailRelatedPageApi.middleware,
      audioPurchasedBookPageApi.middleware
    ),
});
